import { marked } from 'marked'
import DOMPurify from 'dompurify'

function formatJobDescription(text) {
  const rawHtml = marked(text)
  return DOMPurify.sanitize(rawHtml)
}

export default formatJobDescription
